import React, {Component} from 'react';
import {Link} from 'react-router';
import formatNumbers  from 'util/formatNumbers';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import moment from 'moment';

import config from  '../../../config';
import {
    dateFormatter,
    linkFormatter,
    imagesFormatter,
    historyDataFormatter,
    customFormatter,
    prepareSelectOptionsList,
    actionsFormatter,
    priceFormatter,
    getFieldByPathFormatter
} from 'util/Utils';
import {displayCustomDialog}  from 'util/Utils';

import {
    UPDATE_ADMIN_PRODUCT, ADD_SELECTED_PRODUCTS,
    REMOVE_SELECTED_PRODUCTS
} from "actions/actionTypes";


import CustomTableHeaderCheckbox from 'shared/table/CustomTableHeaderCheckbox';


class PartnerProductListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.editProduct = this.editProduct.bind(this);
        this.updateProduct = this.updateProduct.bind(this);


        this.state = {
            perPage: config.table.numberPerPage,
            currentRecord: {},
        };
        // this.allSellersOptionsList = prepareSelectOptionsList(this.props.allSellersList.data, {
        //     label: 'DisplayName',
        //     value: '_id'
        // })
        // this.allSellersOptionsList.unshift({label: 'All', value: 'all'});
    }

    customActionsFormatter(cell, row, extra) {
        var menuItemsMap = [];


        return actionsFormatter.call(this, cell, row, {menuItemsMap})
    }

    componentWillReceiveProps(nextProps) {

        if (_.size(nextProps.allSellersList.data) !== _.size(this.props.allSellersList.data)) {
            this.allSellersOptionsList = prepareSelectOptionsList(nextProps.allSellersList.data, {
                label: 'DisplayName',
                value: '_id'
            })

        }
    }

    editProduct(row) {
        this.context.router.push(`/admin/product/${encodeURIComponent(row._id)}/edit`)
    }

    updateProduct(data) {
        console.log('in update product', data);
        var objectData = {};
        // if (!_.isUndefined(data.event)) { /* for checkboxes*/
        //     //console.log('event', event.target.getAttribute('value'));
        //     if (data.cellName == 'Status') {
        //         objectData[data.cellName] = data.event.target.checked ? 'Active' : 'Inactive';
        //     }
        // } else {
        objectData[data.cellName] = data.row[data.cellName];
        // }
        var methodData = {
            success_event: UPDATE_ADMIN_PRODUCT,
            type: 'patch',
            endpoint: '/products/' + encodeURIComponent(data.row._id),
            messageData: {'#1#': 'Product'},
            messageCode: 'recordUpdated'
        }
        this.props.makeRequest(objectData, methodData).then(function (response) {
            // this.context.router.goBack();
        }.bind(this));
    }

    hideModal() {
        this.setState({currentRecord: {}});
    }


    addCustomClass() {
        return 'center-align-table-column';
    }


    customLinkFormatter(cell, row) {
        return (
            <Link className=""
                  to={`/admin/product/${encodeURIComponent(row._id)}/edit`}>{`${row.ProductName}`}</Link>
        );
    }

    stringToCheckboxFormatter(cell, row, extra) {
        return (
            <input type="checkbox" onChange={(event) => this.updateProduct({row, cellName: extra, event})}
                   defaultChecked={row[extra] == 'Active' ? true : false}>
            </input>
        );
    }

    // stringToSelectboxFormatter(cell, row, extra) {
    //     return (
    //         <Select
    //             tabIndex="0"
    //             placeholder="Seller"
    //             clearable={false}
    //             options={this.allSellersOptionsList}
    //             onChange={(value)=>{this.onSellerChange(row,value)}}
    //             //  filterOptions={filterOptions}
    //             value={row['SellerID'][0]._id}
    //         />
    //     );
    // }

    stringToCheckboxFormatter2(cell, row, extra) {
        return (
            <input type="checkbox" onChange={(event) => this.updateProduct({row, cellName: extra, event})}
                   defaultChecked={row[extra]}>
            </input>
        );
    }


    ShopifyProductLinkFormatter(cell, row, extra) {
        if (row.Status == 'Active') {
            if (_.get(row, extra.path, false)) {
                return linkFormatter(cell, row, extra)
            } else {
                return <div>{_.get(row, extra.labelPath, extra.label ? extra.label : 'Link')} </div>
            }

        } else {

            return <div>{ _.get(row, 'ProductName')}</div>
        }
    }


    onRowSelect(row, isSelected, e) {
        var actionName = isSelected ? ADD_SELECTED_PRODUCTS : REMOVE_SELECTED_PRODUCTS;
        this.props.dispatchAction([row], actionName)
    }

    onAllRowSelect(isSelected, rows) {
        console.log('isSelected', rows);
        var actionName = isSelected ? ADD_SELECTED_PRODUCTS : REMOVE_SELECTED_PRODUCTS;
        this.props.dispatchAction(rows, actionName)
    }

    customMultiSelect(props) {
        if (!_.isUndefined(this.refs.table)) {
            var rowIDs = _.map(this.refs.table.state.data, function (row, key) {
                return row._id;
            });
        }
        var {type, checked, disabled, onChange, rowIndex} = props;

        if (!_.isUndefined(rowIDs) && rowIndex !== 'Header') {
            checked = _.includes(this.props.adminProducts.selectedProducts, rowIDs[rowIndex])
        }

        /*
         * If rowIndex is 'Header', means this rendering is for header selection column.
         */
        if (rowIndex === 'Header') {

            return (
                <div className='checkbox-personalized'>
                    <CustomTableHeaderCheckbox { ...props }/>
                    <label htmlFor={ 'checkbox' + rowIndex }>
                        <div className='check'></div>
                    </label>
                </div>);
        } else {
            return (
                <div className='checkbox-personalized'>
                    <input
                        type={ type }
                        name={ 'checkbox' + rowIndex }
                        id={ 'checkbox' + rowIndex }
                        checked={ checked }
                        disabled={ disabled }
                        onChange={ e => onChange(e, rowIndex) }
                    />
                    <label htmlFor={ 'checkbox' + rowIndex }>
                        <div className='check'></div>
                    </label>
                </div>);
        }
    }

    render() {
        console.log('this.state', this.state);
        var self = this;
        //console.log('this props', this.props);
        const selectRowProp = {
            mode: 'checkbox',
            columnWidth: '29px',
            onSelect: this.onRowSelect.bind(this),
            onSelectAll: this.onAllRowSelect.bind(this),
            customComponent: this.customMultiSelect.bind(this)

        }

        return (
            <div className="  databases-table">
                <BootstrapTable data={this.props.adminProducts.data} ref='table'
                             selectRow={ selectRowProp }
                                remote={ true }
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                } }
                >
                    <TableHeaderColumn width="60px" dataField='ShopifyProductID' dataAlign="center"
                                       dataFormat={ this.ShopifyProductLinkFormatter } formatExtraData={ {
                        labelPath: ['ProductName'],
                        path: ['ShopifyProductHandle'],
                        placeholder: '[product_handle]',
                        template: config.getEnvironment().shopify.productCustomerUrlTemplate
                    } }>Title</TableHeaderColumn>
                    <TableHeaderColumn width="10px" dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                       hiddenOnInsert>Id</TableHeaderColumn>


                    <TableHeaderColumn width="40px" dataFormat={ priceFormatter.bind(this) }
                                       formatExtraData={ {path: ['Price']}} dataField='Price' dataAlign="center"
                                       dataSort={true}>Current Price</TableHeaderColumn>
                    <TableHeaderColumn width="45px"
                                       columnClassName={ this.addCustomClass } dataField='Status' dataAlign="center"
                                       dataSort={true}>Status</TableHeaderColumn>
                    <TableHeaderColumn width="50px" dataField='Condition' dataAlign="center"
                                       dataSort={true}>Condition</TableHeaderColumn>
                    <TableHeaderColumn width="65px" dataField='SKU' dataAlign="center"

                                       dataSort={true}>SKU</TableHeaderColumn>
                    <TableHeaderColumn width="40px" dataField='OriginalPrice' dataAlign="center"
                                       formatExtraData={ {path: ['OriginalPrice']}  } dataFormat={ priceFormatter }
                                       dataSort={true}>Original Price</TableHeaderColumn>

                    <TableHeaderColumn width="50px" dataField='Markets.0.MarketName' dataAlign="center"
                                       dataFormat={ getFieldByPathFormatter }
                                       formatExtraData={ {path: ['Markets', '0', 'MarketName']}} dataSort={true}>Location</TableHeaderColumn>

                    <TableHeaderColumn width="50px" dataField='createdAt' dataAlign="center"
                                       dataFormat={ dateFormatter }
                                       formatExtraData={ {'name': 'createdAt', 'format': 'MM/DD/YY'} }
                                       dataSort={true}>Created date</TableHeaderColumn>
                    <TableHeaderColumn width="35px" dataField='ProductVariants.0.Quantity' dataAlign="center"
                                       formatExtraData={ {path: ['ProductVariants', 0, 'Quantity']}}
                                       dataFormat={ getFieldByPathFormatter } dataSort={true}>Available
                        Qty</TableHeaderColumn>
                    <TableHeaderColumn width="35px" dataField='SoldQuantity' dataAlign="center"
                                       formatExtraData={ {path: ['SoldQuantity']}}
                                       dataFormat={ getFieldByPathFormatter }  >Sold
                        Qty</TableHeaderColumn>
                    <TableHeaderColumn width="150px" height="300px"
                                       columnClassName={  'break-word table-cell-with-image ' }
                                       dataFormat={(cell, row, columnIndex, rowIndex) => {
                                           return <div style={{maxHeight:200, overflow:'auto'}} >{_.map(_.get(row, 'TrackingNumbers', []), function (item, index) {
                                               var styles = {marginTop: 5, paddingLeft:5  }
                                               if (_.get(row, ['TrackingNumbers'], []).length !== index + 1) {
                                                   styles.paddingBottom = 5;
                                                   styles.borderBottom = '1px solid gray';


                                               }

                                               return (<div key={index}  style={styles}>
                                                   { item.TrackingNumber &&
                                                   <div style={{textAlign:'left'}} className="green ">{item.TrackingNumber} </div>
                                                   }

                                                   { item.ImageURL &&
                                                   <div>
                                                       { imagesFormatter.call(self, item, 0, {
                                                           //  displayMultipleImages:true,
                                                           imagePath: ['ImageURL'],
                                                           total: self.props.total,
                                                           perPage: self.state.perPage,
                                                           currentPage: self.props.currentPage,
                                                       })}
                                                   </div>
                                                   }
                                                   { (item.Disposition || self.state.currentRecord.InvoiceCost) &&
                                                   <div className="top5" >
                                                    {item.InvoiceCost &&
                                                       <span  className="purple pull-left">  {formatNumbers.formatMoney(item.InvoiceCost)}</span>
                                                       }

                                                   {item.Disposition &&
                                                   <span   className="orange">  {_.get(_.find(config.dispositionOptions, {value: item.Disposition}), 'label', '') } </span>
                                                   }
                                                   </div>
                                                   }
                                                   { item.ProductItemSKU &&
                                                   <div style={{textAlign:'left'}} className="top5 orange ">{item.ProductItemSKU} </div>
                                                   }
                                                   { item.TrackingNumberAddedAt &&
                                                   <div style={{textAlign:'left'}} className="top5 purple ">{moment(item.TrackingNumberAddedAt).format('YYYY-MM-DD HH:MM')} </div>
                                                   }
                                                   {( item.UserNotes || item.UserImageURL) &&
                                                       <div className="top10">
                                                   <a href="#"  onClick={(e) => {
                                                       e.preventDefault()
                                                       self.setState({
                                                           showTransactionNumberDetails: true,
                                                           currentRecord: item
                                                       })
                                                   }}
                                                   >Additional details</a>
                                                       </div>
                                                   }

                                               </div>)
                                           })}</div>
                                       }}


                                       dataField='TrackingNumbers' dataAlign="center"
                                       dataSort={true}>Tracking Number(s) - Disposition</TableHeaderColumn>

                </BootstrapTable>
                {displayCustomDialog.call(this, {
                    cancelButtonTitle: 'Close',
                    buttonTitle: 'doNotDisplay',
                    dialogContent: () => {
                        return <div>

                            { self.state.currentRecord.UserImageURL &&

                            <div style={{width: 200, margin: '0 auto'}}>
                                <img style={{margin: '0 auto', maxWidth: 200, maxHeight: 200}}
                                     src={self.state.currentRecord.UserImageURL}/>
                            </div>

                            }
                            { self.state.currentRecord.UserNotes &&
                            <div  ><span className="text-bold">User notes:</span> {self.state.currentRecord.UserNotes}
                            </div>
                            }
                        </div>
                    },
                    cancelActionHandler: () => {
                    },
                    confirmActionHandler: (data) => {
                    },
                    modalTitle: 'Details',
                    dialogID: 'TransactionNumberDetails'
                })}
            </div>
        );
    }
}


export default PartnerProductListTable;
